var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#B92026;}\n"),React.createElement("g",{"id":"PLAY_btn","key":1},React.createElement("path",{"id":"Path_47","className":"st0","d":"M237,20c-8.7-10.3-24.7-14.5-55.2-14.5H70.9C39.6,5.5,23.3,10,14.7,21\n\t\tC6.3,31.7,6.3,47.4,6.3,69.2v41.6c0,42.2,10,63.7,64.6,63.7h110.9c26.5,0,41.2-3.7,50.7-12.8c9.7-9.3,13.9-24.5,13.9-50.9V69.2\n\t\tC246.3,46.2,245.7,30.4,237,20z M160.4,95.7L110,122.1c-3.8,2-8.5,0.5-10.4-3.3c-0.6-1.1-0.9-2.3-0.9-3.6V62.7\n\t\tc0-4.3,3.5-7.7,7.7-7.7c1.2,0,2.5,0.3,3.6,0.9L160.4,82c3.8,2,5.3,6.6,3.3,10.4C163,93.8,161.8,95,160.4,95.7L160.4,95.7z"}))]);
}

Play.defaultProps = {"version":"1.1","id":"Слой_1","x":"0px","y":"0px","viewBox":"0 0 252.6 180","style":{"enableBackground":"new 0 0 252.6 180"},"xmlSpace":"preserve"};

module.exports = Play;

Play.default = Play;
